import WriteContainer from "./WriteContainer";

export default WriteContainer;
